import axios from "axios";
import * as yup from "yup";
import { buildQuery } from "utils/queryUtils";

let schema = yup.object().shape({
    clientId: yup.string().test("not-blank", "clientId.required", (clientId) => clientId?.length > 0),
    name: yup.string().test("not-blank", "name.required", (name) => name?.length > 0),
    realmType: yup.string().required().typeError("client.realmType.required"),
    startDate: yup.string().required().typeError("client.startDate.required"),
    redirectUris: yup.array().min(1, "client.redirectUris.required"),
    webOrigins: yup.array().min(1, "client.webOrigins.required"),
});

export const validateClient = (client) => {
    return schema.validate(client, { abortEarly: false });
};

export const findClients = (headers, params) => {
    if (params.filters?.clientId?.value) {
        params.filters.clientId.value = params.filters?.clientId?.value?.toLowerCase();
    }
    let query = buildQuery(params, []);
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/clients${query}`, {
        headers,
    });
};

export const countClients = (headers, params) => {
    let query = buildQuery(params);
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/clients/count${query}`, {
        headers,
    });
};

export const findClientSecret = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/clients/${id}/client-secret`, {
        headers,
    });
};

export const createClient = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_IDP_API_URL}/clients`, data, {
        headers,
    });
};

export const updateClient = (headers, id, data) => {
    return axios.patch(`${process.env.REACT_APP_IDP_API_URL}/clients/${id}`, data, {
        headers,
    });
};

export const updateRoles = (headers, id, data) => {
    return axios.post(`${process.env.REACT_APP_IDP_API_URL}/clients/${id}/roles`, data, {
        headers,
    });
};

export const generateClientSecret = (headers, id) => {
    return axios.post(
        `${process.env.REACT_APP_IDP_API_URL}/clients/${id}/client-secret`,
        {},
        {
            headers,
        }
    );
};
